import React from 'react';
export const About = () => {
  return <section id="about" className="py-20 px-6 md:px-12 bg-black bg-opacity-70" data-id="element-11">
      <div className="max-w-6xl mx-auto" data-id="element-12">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 text-center" data-id="element-13">
          About Me
        </h2>
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-14">
          <div data-id="element-15">
            <p className="text-gray-300 mb-4" data-id="element-16">
              I'm Maila Akbar, a passionate UI/UX Designer with a keen eye for
              detail and a love for creating beautiful, functional digital
              experiences. My approach combines aesthetics with user-centered
              design principles to build interfaces that are both visually
              appealing and intuitive to use.
            </p>
            <p className="text-gray-300 mb-4" data-id="element-17">
              With experience in graphic design and photo editing, I bring a
              versatile skill set to every project. I believe in continuous
              learning and staying updated with the latest design trends and
              technologies to deliver cutting-edge solutions for my clients.
            </p>
            <p className="text-gray-300" data-id="element-18">
              When I'm not designing, I enjoy exploring new design inspirations,
              experimenting with different styles, and collaborating with other
              creative professionals to expand my horizons.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4" data-id="element-19">
            <div className="bg-purple-900 bg-opacity-50 p-6 rounded-lg" data-id="element-20">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-21">UI Design</h3>
              <p className="text-gray-300" data-id="element-22">
                Interface design, Wireframing, Prototyping, Visual Design
              </p>
            </div>
            <div className="bg-purple-900 bg-opacity-50 p-6 rounded-lg" data-id="element-23">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-24">UX Design</h3>
              <p className="text-gray-300" data-id="element-25">
                User Research, Information Architecture, User Flows, Usability
                Testing
              </p>
            </div>
            <div className="bg-purple-900 bg-opacity-50 p-6 rounded-lg" data-id="element-26">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-27">
                Graphic Design
              </h3>
              <p className="text-gray-300" data-id="element-28">
                Brand Identity, Typography, Color Theory, Composition
              </p>
            </div>
            <div className="bg-purple-900 bg-opacity-50 p-6 rounded-lg" data-id="element-29">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-30">
                Photo Editing
              </h3>
              <p className="text-gray-300" data-id="element-31">
                Retouching, Color Correction, Compositing, Image Manipulation
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};